import React                from 'react';
import { WithStyle }        from 'rewire-ui';
import { Theme }            from '@material-ui/core/styles';
import Typography           from '@material-ui/core/Typography';
import TitleWithFlowLogo    from '../ui/TitleWithFlowLogo';
import { withStyles }       from '../utility/styles';

const styles = (_theme: Theme) => ({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '25px 6% 0 6%',
    },
    title: {
      marginTop: '15px',
      marginBottom: '15px',
    },
    message: {
      marginLeft: '10%',
      marginRight: '10%',
    }
  });

interface INoAccessProps {
}

type NoAccessProps = WithStyle<ReturnType<typeof styles>, INoAccessProps>;

class NoAccess extends React.Component<NoAccessProps> {
  constructor(props: NoAccessProps) {
    super(props);
  }

  render() {
    const {classes} = this.props;

    return (
      <div className={classes.root}>
        <TitleWithFlowLogo size='medium' />
        <Typography variant='h4' className={classes.title}>Access Denied</Typography>
        <Typography className={classes.message}>
          You do not have permission to access this feature. If you believe your permission has been wrongfully removed, please contact your account administrator to resolve the issue.
        </Typography>
      </div>
    );
  }
}

export default withStyles<INoAccessProps>(styles, NoAccess);
